<template>
    <Dialog
        header="Редактировать карту"
        class="flex flex-column"
        modal
        v-model:visible="dialogVisible"
        :breakpoints="{'960px': '75vw', '640px': '90vw'}"
        :style="{width: '30vw'}"
    >
        <div class="w-full mb-3">
            <span class="flex text-600 mb-2 text-sm">
                Активность:
            </span>
            <div class="flex align-items-center gap-2">
                <InputSwitch v-model="formData.active" />
                <span>{{ formData.active ? 'Активна' : 'Неактивна' }}</span>
            </div>
        </div>

        <template #footer>
            <Button label="Сохранить" @click="submit()" :loading="loading" />
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        card: {
            type: Object,
            default: null,
        },
    },
    emits: ['update:visible', 'success'],
    data() {
        return {
            loading: false,
            formData: {
                active: false,
            },
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(value) {
                this.$emit('update:visible', value)
            },
        },
    },
    watch: {
        visible(value) {
            if (value) this.syncFormData()
        },
        card: {
            handler() {
                if (this.visible) this.syncFormData()
            },
            deep: true,
        },
    },
    methods: {
        syncFormData() {
            this.formData = {
                active: !!(this.card && this.card.active),
            }
        },
        close() {
            this.dialogVisible = false
        },
        async submit() {
            if (!this.card || !this.card._id) return

            this.loading = true
            const response = await this.connect.AdminUpdateVcard(this.card._id, this.formData).then(res => res)

            if (response.result) {
                this.$toast.add({ severity: 'success', summary: 'Успешно', detail: 'Карта обновлена', life: 2000 })
                this.close()
                this.$emit('success')
            } else {
                if (response.errors && response.errors.length) this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: response.errors[0], life: 3000 })
                else this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка сервера', life: 3000 })
            }

            this.loading = false
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
    },
}
</script>